import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["addressFormCard", "addressDisplayCard", "updatePrimaryButton", "basicSubmitButton", "primaryCheck", "confirmDeleteDiv", "formFields", "validating", "formButtons", "validationErrors"]
  }

  static get values(){
    return {
      editMode: {type: Boolean, default: false},
    };
  }

  connect(){
    $('.selectpicker').selectpicker('refresh');
    this.formButtonsTarget.classList.remove("d-none")
    this.validatingTarget.classList.add("d-none")
    this.addressFormCardTarget.ariaBusy = false
    $(this.formFieldsTarget).LoadingOverlay("hide");
  }

  hideForm(){
    this.editModeValue = false
    this.toggleForm()
  }
  
  toggleForm(){
    this.addressFormCardTarget.classList.toggle("d-none", !this.editModeValue)
    this.addressDisplayCardTarget.classList.toggle("d-none", this.editModeValue)
  }

  cancelNewForm(){
    this.hideForm()
    this.clearForm()
  }
  
  showForm(){
    this.editModeValue = true
    this.toggleForm()
  }

  loadingAnimation(){
    this.addressFormCardTarget.ariaBusy = true
    $(this.formFieldsTarget).LoadingOverlay("show", {
          imageAutoResize: false,
          size: "64px",
        });
    this.formButtonsTarget.classList.add("d-none")
    this.validatingTarget.classList.remove("d-none")
  }

  toggleSubmit(e){
    const isPrimary = this.primaryCheckTarget.checked
    
    this.updatePrimaryButtonTarget.classList.toggle("d-none", !isPrimary)
    this.basicSubmitButtonTarget.classList.toggle("d-none", isPrimary)
  }

  showConfirmDelete(){
    this.confirmDeleteDivTarget.classList.remove("d-none")
  }

  hideConfirmDelete(){
    this.confirmDeleteDivTarget.classList.add("d-none")
  }

  clearForm(){
    const inputs = this.addressFormCardTarget.querySelectorAll("input, select, textarea");
    inputs.forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });
    $(this.addressFormCardTarget).find('.selectpicker').selectpicker('refresh');
    this.validationErrorsTargets.forEach((validationErrorsElement) => {
      validationErrorsElement.classList.add("d-none")
    })
  }
  
}
